import type { ConversationItem } from '@vivport/backend/types';
import { useNavigateWithContentFlush } from '@/hooks';
import { Navigation } from 'lucide-react';

type PageNavigationItem = Extract<ConversationItem, { kind: 'page_navigation' }>;

export interface ProvenancePageNavigationChipProps {
  item: PageNavigationItem;
}

export function ProvenancePageNavigationChip({ item }: ProvenancePageNavigationChipProps) {
  const navigate = useNavigateWithContentFlush();
  return (
    <button
      type="button"
      onClick={() => navigate(item.url)}
      className="inline-flex items-center gap-2 text-xs text-muted-foreground transition-colors hover:text-foreground"
    >
      <Navigation className="h-3.5 w-3.5 shrink-0" />
      <span className="min-w-0 truncate">Opened {item.label}</span>
    </button>
  );
}
